module.exports = __webpack_public_path__ + "img/Қостанай облысы.80ab1add.png";